import { z } from 'zod';
import {
  SUPPORT_EMPLOYEE_RESPONSES,
  SUPPORT_TICKET_STATUSES,
  SUPPORT_TICKET_TYPES,
} from '../enums.js';
import { employeeRef, isoDateTime, listQueryWith, nonEmpty, objectId, timestamps } from './common.js';

export const supportAttachment = z.object({
  id: objectId,
  originalFilename: z.string(),
  mimeType: z.string(),
  sizeBytes: z.number().int(),
});

export const supportMessage = z.object({
  id: objectId,
  author: employeeRef,
  body: z.string(),
  isStaff: z.boolean(),
  createdAt: isoDateTime,
});

export const supportTicket = z
  .object({
    id: objectId,
    reference: z.string(),
    type: z.enum(SUPPORT_TICKET_TYPES),
    status: z.enum(SUPPORT_TICKET_STATUSES),
    subject: z.string(),
    description: z.string(),
    requester: employeeRef,
    attachments: z.array(supportAttachment),
    messages: z.array(supportMessage),
    closedAt: isoDateTime.nullable(),
    closedByStaff: z.boolean(),
    lastActivityAt: isoDateTime,
  })
  .merge(timestamps);

export const supportTicketListQuery = listQueryWith({
  queue: z.enum(['mine', 'technical', 'hr']).optional(),
  status: z.enum(SUPPORT_TICKET_STATUSES).optional(),
  type: z.enum(SUPPORT_TICKET_TYPES).optional(),
});

export const createSupportTicketBody = z.object({
  type: z.enum(SUPPORT_TICKET_TYPES),
  subject: nonEmpty('Subject', 200),
  description: nonEmpty('Description', 5000),
  attachmentFileIds: z.array(objectId).max(5).default([]),
});

export const updateSupportTicketStatusBody = z.object({
  status: z.enum(SUPPORT_TICKET_STATUSES),
  note: z.string().max(2000).optional(),
});

export const createSupportMessageBody = z.object({
  body: nonEmpty('Message', 5000),
});

export const supportEmployeeResponseBody = z.object({
  action: z.enum(SUPPORT_EMPLOYEE_RESPONSES),
  message: z.string().max(5000).optional(),
});

export const supportNotificationSettings = z.object({
  technicalAlertEmails: z.array(z.string().email()).max(20),
  hrAlertEmails: z.array(z.string().email()).max(20),
});

export const updateSupportNotificationSettingsBody = z.object({
  technicalAlertEmails: z.array(z.string().email()).max(20).optional(),
  hrAlertEmails: z.array(z.string().email()).max(20).optional(),
});
